import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDk5G3ZXInN_RMY9BQOz3Qe5sIDiwmje8w",
    authDomain: "otymafarma-dev.firebaseapp.com",
    projectId: "otymafarma-dev",
    storageBucket: "otymafarma-dev.firebasestorage.app",
    messagingSenderId: "45584908779",
    appId: "1:45584908779:web:7f6d53575ac7c4cfcb59ae",
    measurementId: "G-N19EMGEMED"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
export default app;
